const tr = {
  userActives: {
    attributes: {
      id: 'ID',
      name: 'Nome',
      cpf: 'CPF',
      cell_phone: 'Telefone',
      email: 'E-mail',
      corporation: 'Empresa',
    },
    extras: {
      date_init: 'Data inicial',
      date_end: 'Data final',
      search: 'Digite o nome ou CPF',
      considerBranches: 'Considerar filiais',
      considerAllBranches: 'Considerar todas filiais',
      consider: 'Considerar',
    },
    defSingular: 'Relatório de usuários ativos por empresa',
  },
};

export default tr;
